module.exports = __webpack_public_path__ + "img/icon_checkdone.87982509.svg";